<template>
  <div class="vis-box-container" v-loading="loading">
    <div class="vis-box" ref="visContainer"></div>
    <showDetail ref="showDetail" :ids="ids" :detail="detail" @close="detail = null" @tab-change="tabChange" />
  </div>
</template>
<script>
import * as vis from 'vis-network'
import { DataSet } from 'vis-data'
import 'vis-network/styles/vis-network.css'
import showDetail from './showDetail.vue'
import { getRecordedIn, nameAddress } from '@/api/home'
import { Message } from 'element-ui'
import { i18n } from '@/i18n'
export default {
  name: 'VisIndex',
  components: {
    showDetail
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    showDetail: {
      type: Boolean,
      default: true
    },
    arrows: {
      type: Boolean,
      default: true
    },
    // 是否影藏贡献的文字和箭头
    hideCoOccurrence: {
      type: Boolean,
      default: false
    },
    // 是否禁用连线点击
    lineDisableClick: {
      type: Boolean,
      default: false
    },
    // 连线颜色
    lineColors: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      detail: null,
      loading: false,
      nodes: [],
      edges: [],
      ids: [],
      lineColorMap: {}
    }
  },
  mounted () {
    this.initVis()
  },
  beforeDestroy () {
    this.network?.destroy()
    if (window.gc) window.gc() // Chrome强制垃圾回收
  },
  watch: {
    data: {
      handler (val) {
        // 手动清理内存
        this.network && this.network.body.data.nodes.clear()
        this.network && this.network.body.data.edges.clear()
        this.initVis()
      },
      deep: true
    }
  },
  methods: {
    tabChange (Id) {
      this.$emit('tab-change', Id)
    },
    addNodes (nodes, edges) {
      this.nodes.update(nodes.map(e => ({
        rootSource: e,
        id: e.Id,
        label: e.Name,
        group: e.labels,
        shape: 'circle',
        font: {
          inside: true,
          multi: true,
          align: 'center'
        },
        widthConstraint: {
          maximum: 18
        }
      })))
      this.edges.update(edges.map(e => {
        const row = {
          rootSource: e,
          from: e.source,
          to: e.target,
          label: e.value,
          type: 'curveEdge',
          width: 1
        }
        if (!this.hideCoOccurrence && this.arrows) {
          row.arrows = { to: { enabled: true, scaleFactor: 0.2, type: 'arrow' } }
        }
        if (this.hideCoOccurrence && e.value === i18n.$t('共现')) {
          row.label = ''
        }
        return row
      }))
      this.network.stabilize()
      this.updateNodesLinghtColor()
    },
    updateNodesLinghtColor () {
      const ids = this.data.data.filter(e => e.top10).map(e => e.Id)
      if (ids.length) {
        this.nodes.update(ids.map(e => {
          const row = {
            id: e,
            color: {
              background: '#ffffff',
              border: '#B22222'
            }
          }
          return row
        }))
      }
    },
    initVis () {
      if (this.data) {
        if ((this.data.data || []).length) {
          this.loading = true
        }
        const list = (this.data.data || []).map(e => {
          const r = {
            rootSource: e,
            id: e.Id,
            label: e.Name,
            group: e.labels,
            shape: 'circle',
            font: {
              inside: true,
              multi: true,
              align: 'center'
            },
            color: {
              background: '#ffffff',
              border: '#D8BD98'
            },
            widthConstraint: {
              maximum: 18
            }
          }
          if (e.top10 === 1) {
            r.color = {
              background: '#ffffff',
              border: '#D35400'
            }
          } else {
            if (this.data.searchKey && ((this.data.condition === 'eq' && e.Name === this.data.searchKey) || (this.data.condition !== 'eq' && e.Name.includes(this.data.searchKey)))) {
              r.color = {
                background: '#ffffff',
                border: '#83240E'
              }
            }
            if ((this.data.start_name && e.Name.includes(this.data.start_name)) || (this.data.end_name && e.Name.includes(this.data.end_name))) {
              r.color = {
                background: '#ffffff',
                border: '#83240E'
              }
            }
          }
          return r
        })
        // 创建节点和边数据
        this.nodes = new DataSet(list)
        // 关系
        this.edges = new DataSet(this.data.link.map(e => {
          let color = ''
          if (this.lineColors && this.lineColors.length) {
            const colorLeng = Object.keys(this.lineColorMap)
            color = this.lineColorMap[e.value] ? this.lineColorMap[e.value] : this.lineColors[colorLeng.length]
            this.lineColorMap[e.value] = color
          }
          const row = {
            rootSource: e,
            from: e.source,
            to: e.target,
            label: e.value,
            type: 'curveEdge',
            width: 1
          }
          if (color) {
            row.color = color
          }
          if (!this.hideCoOccurrence && this.arrows) {
            row.arrows = { to: { enabled: true, scaleFactor: 0.2, type: 'arrow' } }
          }
          if (this.hideCoOccurrence && e.value === i18n.$t('共现')) {
            row.label = ''
          }
          return row
        }))
        // 配置选项
        const options = {
          // layout: {
          //   improvedLayout: true,
          //   levelSeparation: 8000
          // },
          groups: {
            Person: { color: { background: '#ffffff', border: '#D8BD98' } },
            Address: { color: { background: '#ffffff', border: '#D8BD98' } },
            RecordedIn: { color: { background: '#ffffff', border: '#D8BD98' } }
          },
          nodes: {
            shapeProperties: {
              useBorderWithImage: true
            },
            shape: 'dot',
            size: 10,
            color: {
              highlight: {
                // background: '#987443'
                background: '#ffffff',
                border: '#83240E'
              }
            },
            font: {
              inside: true,
              size: 6,
              color: '#333333'
            },
            borderWidthSelected: 4,
            borderWidth: 4
          },
          edges: {
            width: 0,
            color: {
              color: '#BAA07D',
              highlight: '#7d541c',
              hover: '#A80000'
            },
            selectionWidth: 0.5,
            hoverWidth: 0.5,
            smooth: false,
            font: {
              bold: 'normal',
              size: 6,
              color: '#333333',
              strokeWidth: 0
            }
          },
          physics: {
            stabilization: { iterations: 500 },
            barnesHut: {
              gravitationalConstant: -40000, // 调整引力常数来改变节点间的吸引程度
              centralGravity: 0.2, // 中心引力强度
              springLength: 20, // 弹簧长度，影响节点间的距离
              springConstant: 0.1 // 弹簧常数，影响节点间连接的紧密度
            }
          }
        }

        // 创建网络
        this.network = new vis.Network(
          this.$refs.visContainer,
          { nodes: this.nodes, edges: this.edges },
          options
        )
        this.updateNodesLinghtColor()
        this.network.setOptions({ physics: false })
        this.network.stabilize(200)
        this.network.on('stabilizationIterationsDone', () => {
          this.loading = false
        })
        let timer = null
        if (this.showDetail) {
          this.network.on('click', (e) => {
            this.ids = []
            timer && clearTimeout(timer)
            timer = setTimeout(() => {
              if (e && e.nodes && e.nodes.length) { // 点击节点
                // this.detail = [
                //   ...this.data.data
                // ].find(d => d.Id === e.nodes[0])
                const nodeItem = this.nodes.get(e.nodes[0])
                if (nodeItem.group === 'Address') {
                  // 设置ID
                  nameAddress({
                    name: nodeItem.label
                  }).then(res => {
                    this.ids = res.data
                    this.detail = nodeItem.rootSource
                  })
                } else {
                  this.detail = nodeItem.rootSource
                }
              } else if (e && e.edges && e.edges.length) { // 点击线
                this.$refs.showDetail.close()
                if (this.lineDisableClick) return false
                const edgeId = e.edges[0] // 获取边的ID
                // const connectedNodes = this.network.getConnectedNodes(edgeId)
                // const link = this.data.link.find(d => d.source === connectedNodes[0] && d.target === connectedNodes[1])
                const link = this.edges.get(edgeId).rootSource
                // 显示记载于
                if (link && link.RecordedIn) {
                  this.ids = link.Ids.map(e => {
                    const list = e.split('-')
                    if (list.length > 1) {
                      list.pop()
                    }
                    return {
                      Name: list.join('-'),
                      Id: e
                    }
                  })
                  getRecordedIn({
                    // recorded_in: link.RecordedIn
                    id: link.Ids[0]
                  }).then(res => {
                    this.detail = res.data.data
                  })
                } else {
                  Message.warning(i18n.$t('暂无记载'))
                }
              } else {
                this.$refs.showDetail.close()
              }
            }, 300)
          })
        }
        this.network.on('doubleClick', (e) => {
          timer && clearTimeout(timer)
          if (e && e.nodes && e.nodes.length) { // 双击节点
            const nodeItem = this.nodes.get(e.nodes[0])
            if (nodeItem.rootSource) {
              this.$emit('doubleClick', nodeItem.rootSource)
            }
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.vis-box-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.vis-box {
  width: 100%;
  height: 100%;
}
</style>
